var Delivery = (function (Backbone, AddressForm, AddressGiftForm, AddressBillingForm, DeliveryAddress, Addresses, BillingAddress, DeliveryModeSwitcherModel) {
	return Backbone.Model.extend({
		defaults: {
			Form: new AddressForm([]),
            GiftForm: new AddressGiftForm([]),
            BillingForm: new AddressBillingForm([]),
			Current: new DeliveryAddress(),
			CurrentGiftAddress: new GiftAddressModel(),
			CurrentBilling: new BillingAddressModel(),
            GiftMessage: new GiftMessageModel(),
			Addresses: new Addresses([]),
			BillingAddress: new BillingAddress(),
            DeliveryModeSwitcher: new DeliveryModeSwitcherModel(),
			// TDB: should be in the current address (like it done for Addresses).
			PickupPointField: new PickupPointField({}, { saveOnSelect: true })
        },

		isValid: function () {
			if (this.form().isActive()) {
				return this.form().isValid();
			} else if (this.addresses().isActive()) {
				return this.addresses().isValid();
			} else {
				return this.current().isValid();
			}
		},

		current: function (data) {
			var address = this.get('Current');
			if (data) address.setData(data);
			return address;
		},

		currentGiftAddress: function (data) {
			var address = this.get('CurrentGiftAddress');
			if (data) address.setData(data);
			return address;
		},

		currentGiftMessage: function (message, giftOccasion, giftDateStr) {
			var occasionModel = this.get('GiftMessage');
			occasionModel.setData(message, giftOccasion, giftDateStr);
			return occasionModel;
		},

		currentBilling: function (data) {
			var address = this.get('CurrentBilling');
			if (data) address.setData(data);
			return address;
		},

		form: function (data, isPickupPointsEnabled) {
			var form = this.get('Form');
			if (data) {
				form.update(data);
				form.pickupPointField.setIsEnabled(isPickupPointsEnabled);
			}
			return form;
		},

		giftForm: function (data) {
            var form = this.get('GiftForm');
			if (data) {
                form.setDecoration(data);
			}
			return form;
		},

		billingForm: function (data, currentAddress) {
            var form = this.get('BillingForm');
			if (data) {
				form.setDecoration(data, currentAddress);
			}
			return form;
		},

		billingAddress: function (data) {
			var billing = this.get('BillingAddress');
			data && billing.setData(data);
			return billing;
		},

        deliveryModeSwitcher: function (data) {
            var _deliveryMode = this.get('DeliveryModeSwitcher');
            data && _deliveryMode.setData(data.BasketMode || 0);
            return _deliveryMode;
		},

		addresses: function () {
			return this.get('Addresses');
		},

		pickupPointField: function () {
			return this.get('PickupPointField');
		},

		hasCurrent: function () {
			return Boolean(this.current().id);
		},

		update: function (data) {
			if (!data.Current || !data.Current.ID) {
                if (window.localStorage) {
					var usepostcode = ((JSON.parse(localStorage.getItem('userPostCode')) || '') + '') || null;
                    usepostcode = usepostcode === 'null' ? null : usepostcode;
                    var postcode = _.where(data.DecorationInfoList, { Name: 'Postcode' });
					if (usepostcode && postcode && postcode[0]) {
                        postcode[0].Value = usepostcode;
                    }
                }
            }

			this.deliveryModeSwitcher(data);

			var _currentAddress = null;

            data.Current.BasketMode = data.BasketMode;
			if (data.BasketMode === 0) {
                _currentAddress = data.Current;
                this.current(data.Current);
                this.currentGiftAddress({ID: null});
			} else {
				this.current({ ID: null });
				this.currentGiftAddress(data.Current);
				this.currentGiftMessage(data.GiftMessage, data.GiftOccasion, data.GiftDateStr);
            }

			this.currentBilling(data.BillingAddress);
			this.form(data.DecorationInfoList, data.isPickupPointsEnabled);
            this.giftForm(data.DecorationInfoList);
            this.billingForm(data.DecorationInfoList, _currentAddress);

            this.billingAddress(data.BillingAddress);

			// TDB: should be in the current address (like it done for Addresses).
			this._updatePickupPointField(data);

			// TBD: use CheckoutApiModel as parent of this class and delete this triggering.
			this.trigger('update', this);
		},

		_updatePickupPointField: function (data) {
			var pickupPointField = this.pickupPointField();
			var additionalData = data.Current && data.Current.AdditionalData;
			try {
				additionalData = JSON.parse(additionalData || null);
			} catch (e) {
				window.NREUM && _.isFunction(window.NREUM.noticeError) && window.NREUM.noticeError(e);
				additionalData = null;
			}

			pickupPointField
				.clear()
				.setIsEnabled(data.isPickupPointsEnabled)
				.setSelectedPickupPoint(additionalData, { silent: false });
		},
		isPickupPointsEnabled: function() {
			return this.pickupPointField().isEnabled();
		},
		hasBillingAddress: function() {
			return this.billingAddress().hasBilling();
		}
	});
})(Backbone, AddressForm, AddressGiftForm, AddressBillingForm, DeliveryAddress, Addresses, BillingAddress, DeliveryModeSwitcherModel);
